import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const STORAGE_KEY = "cardora_cookie_consent";

function CookieConsent() {
  const [choice, setChoice] = useState(() => localStorage.getItem(STORAGE_KEY));

  useEffect(() => {
    if (choice) localStorage.setItem(STORAGE_KEY, choice);
  }, [choice]);

  if (choice) return null;

  return (
    <aside className="cookie-consent" aria-label="Consentimiento de cookies">
      <div>
        <strong>Cookies en Cardora</strong>
        <span>
          Usamos cookies necesarias para la sesion. Las analiticas solo se activaran si las aceptas.
        </span>
        <Link to="/legal/cookies">Ver politica de cookies</Link>
      </div>
      <div className="cookie-consent-actions">
        <Button size="sm" variant="outline-dark" onClick={() => setChoice("necessary")}>
          Rechazar no necesarias
        </Button>
        <Button size="sm" className="btn-cardora" onClick={() => setChoice("all")}>
          Aceptar
        </Button>
      </div>
    </aside>
  );
}

export default CookieConsent;
